<div class="mx-auto max-w-screen-desktop container-padding pt-16 pb-24 lg:pt-24 lg:pb-32 mt-8 tablet:mt-12">
  <div class="flex flex-col tablet:flex-row justify-between items-start tablet:items-center mb-10 gap-4">
    <h1 class="uppercase text-[42px]/[42px] tablet:text-[56px]/[56px] font-normal m-0 tracking-tight text-[var(--black)]">
      {{ 'cart.title' | translate }}
    </h1>
    <div class="w-full tablet:w-auto flex justify-start tablet:justify-end">
      <a *ngIf="cartItems.length > 0" (click)="goToHome()" class="font-semibold underline cursor-pointer text-[var(--dark-grey)] hover:text-[var(--black)] uppercase text-sm">{{ 'cart.continueShopping' | translate }}</a>
    </div>
  </div>

  <!-- Modal: Login requerido -->
  <div *ngIf="showLoginModal"
       class="fixed inset-0 z-[99999] flex items-center justify-center px-4"
       (click)="showLoginModal = false">
    <div class="absolute inset-0 bg-black/60 backdrop-blur-sm"></div>

    <div class="relative w-full max-w-[400px] bg-white border-4 border-[var(--black)] rounded-2xl shadow-2xl overflow-hidden"
         (click)="$event.stopPropagation()">

      <!-- Franja naranja superior -->
      <div class="h-2 bg-[var(--secondary)]"></div>

      <div class="px-8 pt-7 pb-8 flex flex-col items-center text-center gap-4">

        <!-- Icono de candado -->
        <div class="w-16 h-16 rounded-full bg-[var(--light-grey)] border-4 border-[var(--black)] flex items-center justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 448 512" fill="var(--black)">
            <path d="M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z"/>
          </svg>
        </div>

        <!-- Texto -->
        <div>
          <h2 class="text-[22px] font-bold uppercase text-[var(--black)] leading-tight mb-1">
            {{ 'cart.loginRequired' | translate }}
          </h2>
          <p class="text-[14px] text-[var(--dark-grey)] leading-snug">
            {{ 'cart.loginRequiredDesc' | translate }}<br>
            {{ 'cart.cartSaved' | translate }}
          </p>
        </div>

        <!-- Botones -->
        <div class="flex flex-col gap-3 w-full mt-2">
          <button (click)="goToLogin()"
            class="w-full py-3 rounded-xl bg-[var(--black)] text-white font-bold uppercase text-[13px] tracking-wide hover:opacity-80 transition-opacity">
            {{ 'cart.loginBtn' | translate }}
          </button>
          <button (click)="goToRegister()"
            class="w-full py-3 rounded-xl bg-[var(--secondary)] text-white font-bold uppercase text-[13px] tracking-wide hover:opacity-80 transition-opacity">
            {{ 'cart.createAccount' | translate }}
          </button>
          <button (click)="showLoginModal = false"
            class="text-[12px] text-[var(--dark-grey)] hover:text-[var(--black)] transition-colors underline">
            {{ 'cart.backToCart' | translate }}
          </button>
        </div>

      </div>
    </div>
  </div>

  <div *ngIf="errorMessage" class="bg-[var(--bordeaux)] text-white p-4 rounded-xl mb-6 shadow-sm">
    {{ errorMessage }}
  </div>

  <div *ngIf="cartItems.length === 0" class="text-center py-16 mb-16 bg-[var(--light-grey)] rounded-2xl border-4 border-[var(--black)]">
    <p class="text-[18px]/[27px] font-[400] text-[var(--dark-grey)] mb-6">{{ 'cart.empty' | translate }}</p>
    <div class="flex flex-col mobile-m:flex-row gap-3 justify-center items-center">
      <app-button [function]="goToEvents.bind(this)" [text]="'cart.viewEvents' | translate" [styleType]="'primary'"></app-button>
      <app-button [function]="goToNewHop.bind(this)" [text]="'cart.createRoute' | translate" [styleType]="'primary'"></app-button>
    </div>
  </div>

  <div *ngIf="cartItems.length > 0" class="grid grid-cols-1 tablet:grid-cols-12 gap-8 tablet:gap-12 mb-16">
    <!-- Items List -->
    <div class="col-span-1 tablet:col-span-8 desktop:col-span-9 flex flex-col gap-6">
      <div *ngFor="let item of cartItems; let i = index; trackBy: trackByIndex" 
           class="bg-[var(--white)] border-4 border-[var(--black)] rounded-2xl p-6 shadow-sm">
        
        <div class="flex flex-col gap-4">
          
          <!-- Top Row: Title & Remove Button -->
          <div class="flex flex-row justify-between items-start gap-4">
            <div>
              <h3 class="text-xl font-normal uppercase leading-none" *ngIf="item.typeId === 1">{{ item.eventTitle }}</h3>
              <h3 class="text-xl font-normal uppercase leading-none" *ngIf="item.typeId === 2">{{ 'cart.customRoute' | translate }}</h3>

              <!-- Fecha evento -->
              <div *ngIf="item.typeId === 1" class="text-[var(--dark-grey)] text-xs mt-1">
                {{ 'cart.date' | translate }} {{ item.eventDate | date: 'dd/MM/yyyy' }}
              </div>
              <!-- Fecha vencimiento recorrido custom -->
              <div *ngIf="item.typeId === 2" class="text-[var(--dark-grey)] text-xs mt-1">
                {{ 'cart.validUntil' | translate }} {{ getCustomRouteExpiry() | date: 'dd/MM/yyyy' }}
              </div>

              <!-- Botón "Ver sucursales" -->
              <div class="mt-2">
                <button
                  (click)="toggleBranches(i)"
                  class="inline-flex items-center gap-1 text-xs font-semibold text-[var(--dark-grey)] hover:text-[var(--black)] transition-colors"
                >
                  <span>📍 {{ 'cart.branches' | translate }}</span>
                  <svg
                    [class.rotate-180]="expandedItems.has(i)"
                    class="w-3 h-3 transition-transform duration-200"
                    fill="none" stroke="currentColor" stroke-width="2.5"
                    viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"/>
                  </svg>
                </button>

                <!-- Panel desplegable -->
                <div
                  *ngIf="expandedItems.has(i)"
                  class="mt-2 flex flex-wrap gap-1.5"
                >
                  <!-- Tipo 1: sucursales del evento -->
                  <ng-container *ngIf="item.typeId === 1">
                    <span *ngFor="let branch of item.eventBranches"
                      class="px-2.5 py-1 rounded-full text-[11px] font-medium bg-white text-[var(--black)] border border-[var(--grey)]">
                      {{ branch.name }} · {{ branch.address }}
                    </span>
                  </ng-container>
                  <!-- Tipo 2: sucursales del recorrido -->
                  <ng-container *ngIf="item.typeId === 2">
                    <span *ngFor="let name of item.branchNames"
                      class="px-2.5 py-1 rounded-full text-[11px] font-medium bg-white text-[var(--black)] border border-[var(--grey)]">
                      {{ name }}
                    </span>
                  </ng-container>
                </div>
              </div>
            </div>
            <button class="text-[var(--bordeaux)] hover:text-red-700 font-semibold underline text-sm whitespace-nowrap" (click)="removeItem(i)">{{ 'cart.remove' | translate }}</button>
          </div>


          <!-- Content Section: Prices, Quantity & Attendees -->
          <div class="grid grid-cols-1 tablet:grid-cols-12 gap-6 pt-4 mt-2 border-t border-[var(--grey)]">
            
            <!-- Left Column: Quantity & Attendees -->
            <div class="tablet:col-span-8 desktop:col-span-9 grid grid-cols-1 mobile-m:grid-cols-3 gap-6">
              
              <!-- Quantity Column -->
              <div class="mobile-m:col-span-1 flex flex-col gap-3">
                <span class="font-bold text-[var(--black)] text-sm uppercase">{{ 'cart.quantity' | translate }}</span>
                <div class="flex">
                  <app-quantity-stepper
                    [quantity]="item.quantity"
                    [min]="1"
                    [max]="20"
                    (quantityChange)="updateQuantity(i, $event)"
                  ></app-quantity-stepper>
                </div>
              </div>

              <!-- Attendees Column -->
              <div class="mobile-m:col-span-2 flex flex-col gap-3">
                <span class="font-bold text-[var(--black)] text-sm uppercase">{{ 'cart.attendees' | translate }}</span>
                <div class="flex flex-col gap-2">
                  <div *ngFor="let name of item.visitorNames; let j = index; trackBy: trackByIndex" class="flex flex-col gap-1">
                    <input 
                      type="text" 
                      [ngModel]="name" 
                      (ngModelChange)="updateVisitorName(i, j, $event)"
                      [placeholder]="'Nombre y Apellido Asistente ' + (j + 1)"
                      required
                      maxlength="40"
                      (keypress)="onlyLetters($event)"
                      (input)="sanitizeVisitorName(i, j, $event)"
                      [ngClass]="isFieldInvalid(i, j) ? 'border-[var(--bordeaux)] focus:border-[var(--bordeaux)] text-[var(--bordeaux)] bg-red-50' : 'border-[var(--grey)] focus:border-[var(--black)] bg-white'"
                      class="appearance-none block w-full px-3 py-1.5 border-2 rounded-lg focus:outline-none focus:ring-0 font-medium text-sm transition-colors shadow-sm"
                    />
                    <span *ngIf="isFieldInvalid(i, j)" class="text-[0.65rem] md:text-xs text-[var(--bordeaux)] font-semibold ml-1 leading-tight">{{ 'cart.nameRequired' | translate }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Right Column: Prices -->
            <div class="tablet:col-span-4 desktop:col-span-3 flex flex-col justify-start gap-4">
              <div class="flex justify-between items-center tablet:flex-col tablet:items-end tablet:gap-1">
                <span class="text-xs font-bold text-[var(--dark-grey)] uppercase">{{ 'cart.unitPrice' | translate }}</span>
                <span class="font-bold text-[var(--black)] text-lg">{{ item.pricePerUnit | currency }}</span>
              </div>
              <div class="flex justify-between items-center tablet:flex-col tablet:items-end tablet:gap-1">
                <span class="text-xs font-bold text-[var(--dark-grey)] uppercase">{{ 'cart.subtotal' | translate }}</span>
                <span class="font-bold text-[var(--secondary)] text-2xl">{{ getSubtotal(item) | currency }}</span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Summary -->
    <div class="col-span-1 tablet:col-span-4 desktop:col-span-3 border-4 border-[var(--black)] bg-[var(--white)] rounded-2xl p-6 shadow-sm h-fit tablet:sticky tablet:top-24">
      <h2 class="uppercase text-[32px]/[40px] font-normal text-[var(--black)] mb-6 border-b border-[var(--grey)] pb-4">{{ 'cart.summary' | translate }}</h2>
      
      <div class="flex flex-col gap-4 mb-6">
        <div class="flex justify-between items-center">
          <span class="text-[var(--dark-grey)]">{{ 'cart.subtotal' | translate }}</span>
          <span class="font-semibold text-[var(--black)]">{{ getCartSubtotal() | currency }}</span>
        </div>
        <div class="flex justify-between items-center">
          <span class="text-[var(--dark-grey)]">{{ 'cart.tax' | translate }}</span>
          <span class="font-semibold text-[var(--black)]">{{ getCartTax() | currency }}</span>
        </div>
        <div class="flex justify-between items-center mt-2 pt-4 border-t border-[var(--black)] text-xl">
          <span class="font-bold text-[var(--black)]">{{ 'cart.total' | translate }}</span>
          <span class="font-bold text-[var(--secondary)]">{{ getCartTotal() | currency }}</span>
        </div>
      </div>

      <div class="flex flex-col gap-4 mt-8">
        <app-button 
          [function]="proceedToCheckout.bind(this)" 
          [text]="isProcessing ? ('cart.processing' | translate) : ('cart.proceedToPayment' | translate)" 
          [styleType]="'primary-flat'" 
          [fullWidth]="true"
          [disabled]="isProcessing"
        ></app-button>
      </div>
    </div>
  </div>
</div>
